import React, { useEffect } from "react";
import classNames from "classnames";
import { Product } from "../../types";

interface DropDownSelectorProps {
  options: Product[];
  onOptionChange: (index: number) => void;
  optionIndex: number;
  containerClassName?: string;
}

export const DropDownSelector: React.FC<DropDownSelectorProps> = ({
  options,
  onOptionChange,
  optionIndex,
  containerClassName,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const onSelectItem = (index: number) => {
    onOptionChange(index);
    setIsOpen(false);
  };

  return (
    <div className={classNames("relative w-full", containerClassName)}>
      <button
        onClick={toggle}
        className="w-full border border-auctionStroke py-[14px] px-[20px] text-[22px] flex flex-row justify-between "
        type="button"
      >
        <p>select</p>
        <p className="font-bold">
          {options[optionIndex]?.native_variant_descriptor ?? ""}
        </p>
      </button>
      <div
        className={classNames(
          "z-10 shadow absolute w-full bg-white",
          !isOpen && "hidden"
        )}
      >
        <ul
          className="py-1 text-sm text-gray-700 dark:text-gray-200"
          aria-labelledby="dropdownButton"
        >
          {options.map((option, index) => {
            return (
              <li key={index} className="text-[22px] font-bold w-full ">
                <button
                  className="w-full py-[14px] px-[20px]"
                  onClick={() => onSelectItem(index)}
                >
                  {option.native_variant_descriptor}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DropDownSelector;

